<template>
    <div>
        <div v-if="getLastMeasure != null"><strong>Ultima lectura:</strong> {{ format_date(getLastMeasure.measured_at) }} - {{ fromNowDate(getLastMeasure.measured_at) }}</div>

        <table id="example1" class="table table-bordered table-striped">
            <thead>
            <tr>
                <th>Fecha</th>
                <th>Valor</th>
                <th>Unidad</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(measure, index) in orderedMeasures" :key="measure.id">
                <td>{{ format_date(measure.measured_at) }}</td>
                <td>{{ measure.value_key }}</td>
                <td>{{ measure.value_unit_name }} ({{ measure.value_unit }})</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
    //computed: mapState(['measures']),
    data() {
        return {
            'elementKeyUUID': this.getElementKeyUUID()
        }
    },
    created() {
        axios.get('/api/v1/element_keys/' + this.elementKeyUUID + '/measures')
            .then(response => {
                this.$store.commit('setMeasures', response.data.data);
            })
            .catch(error => {
                console.log("Error", error)
            })
    },
    methods: {
        format_date(value) {
            //TODO: DRY global?
            if (value) {
                return window.moment(String(value)).format('DD-MM-YYYY hh:mm:ss')
            }
        },
        fromNowDate(date) {
            if (date) {
                return window.moment(String(date)).fromNow();
            }
        },
        getElementKeyUUID() {
            //TODO: DRY
            let elementKeyUUID = document.head.querySelector('meta[name="meta-elementKeyUUID"]');

            if (elementKeyUUID) {
                return elementKeyUUID.content;
            } else {
                console.error('elementKeyUUID meta not found.');
            }
        }
    },
    computed: {
        orderedMeasures: function () {
            return _.orderBy(this.$store.state.measures, 'id', 'desc')
        },
        getLastMeasure() {
            let sortedMeasuresByDate = this.$store.state.measures.sort(function(a,b){
                return Date.parse(a.measured_at) < Date.parse(b.measured_at);
            });

            if (sortedMeasuresByDate[0] === undefined) {
                return null;
            }

            return sortedMeasuresByDate[0];
        }
    }

}
</script>
